import GLOBALS from '../utils/Constants';
import UserService from './users-service';
import UtilsService from './utils-service';

export default class IncidentsService {

    static sharedInstance = IncidentsService.sharedInstance == null ? new IncidentsService() : this.sharedInstance;

    constructor(){
        //initialize
        this.credentials = UserService.sharedInstance.getStoredCredentials();
        this.auth_username = this.credentials.username;
        this.license = this.credentials.license;
        this.token = this.credentials.token;
    }

    getUpdatedCrendetials(){
        this.credentials = UserService.sharedInstance.getStoredCredentials();
        this.auth_username = this.credentials.username;
        this.license = this.credentials.license;
        this.token = this.credentials.token;
    }

    async add(params){
        let data = new FormData();

        for (let i = 0; i <  params.files.length; i++) {
            data.append("files[]", params.files[i]);
            //console.log(“PARAMS”, params.files[i]);
        }

        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("dispatch_no", params.dispatch_no)
        data.append("incident_type_id", params.incident_type_id); //expecting multiple files
        data.append("facility_id", params.facility_id);
        data.append("facility_location_id", params.facility_location_id);
        data.append("location_description", params.location_description);
        data.append("individuals_data", params.individuals_data)
        data.append("external_agency_data", params.external_agency_data); //expecting multiple files
        data.append("auto_email_id", params.auto_email_id);
        data.append("date_added", params.date_added);
        data.append("license", params.license);
        data.append("other_form_data", params.other_form_data);


        const response = await fetch(GLOBALS.ADD_INCIDENTS_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in adding incident." + error);
        }
    }

    async edit(params){
        let data = new FormData();

        // data.append("files", params.file); //expecting multiple files
        for (let i = 0; i <  params.files.length; i++) {
            data.append("files[]", params.files[i]);
            //console.log(“PARAMS”, params.files[i]);
        }

        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("dispatch_no", params.dispatch_no)
        data.append("incident_type_id", params.incident_type_id); //expecting multiple files
        data.append("facility_id", params.facility_id);
        data.append("facility_location_id", params.facility_location_id);
        data.append("location_description", params.location_description);
        data.append("individuals_data", params.individuals_data)
        data.append("external_agency_data", params.external_agency_data); //expecting multiple files
        data.append("other_form_data", params.other_form_data);
        data.append("auto_email_id", params.auto_email_id);
        data.append("date_added", params.date_added);
        data.append("license", params.license);
        data.append("id", params.id);

        //NOTE: set this flag to 1 if there are attachment changes, it deletes the curretn attachments of the incidents and uploaded the new passed files
        data.append("update_attachments_flag", params.update_attachments_flag);

        const response = await fetch(GLOBALS.UPDATE_INCIDENTS_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        //console.log("Incident", responseJson);
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            // console.log(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in updating incident.");
        }
    }

    async getAll(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);


        const response = await fetch(GLOBALS.GET_ALL_INCIDENTS_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();

        try {
            //console.log(responseJson);
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Incident fetch failed.");
        }
    }

    async delete(params){

        const formBody = UserService.sharedInstance.urlEncodeParams(params);
        const response = await fetch(GLOBALS.DELETE_INCIDENTS_API, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error(error);
        }
    }

    async getIncidentInfoByID(params){
        /**params
            id:32
            token:{{token}}
            license:{{license}}
            auth_username:{{auth_username}}
        **/
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_INCIDENTS_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            //console.log(responseJson);
            //UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Incident fetch failed.");
        }
    }

    //Live Nation and Future Incident Forms
    async addCustomIncident(params){
        let data = new FormData();

        for (let i = 0; i <  params.files.length; i++) {
            data.append("files[]", params.files[i]);
            //console.log(“PARAMS”, params.files[i]);
        }

        //Auth Params
        data.append("license", params.license);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);

        //Form Details
        data.append("sub_user_id", params.sub_user_id);
        data.append("event_id", params.event_id);
        data.append("facility_id", params.facility_id);
        data.append("facility_location_id", params.facility_location_id);
        data.append("individuals_data", params.individuals_data) //offenders data
        data.append("date_added", params.date_added);
        data.append("other_form_data", params.other_form_data); //json data for all other fields

        data.append("incident_form_type", "live_nation"); //live_nation, or other incident form types


        //same API call for adding standard incidents
        const response = await fetch(GLOBALS.ADD_INCIDENTS_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();

        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in adding incident." + error);
        }
    }

    async editCustomIncident(params){
        let data = new FormData();

        for (let i = 0; i <  params.files.length; i++) {
            data.append("files[]", params.files[i]);
            //console.log(“PARAMS”, params.files[i]);
        }

        //Auth Params
        data.append("license", params.license);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);

        //Form Details
        data.append("id", params.id);
        data.append("sub_user_id", params.sub_user_id);
        data.append("event_id", params.event_id);
        data.append("facility_id", params.facility_id);
        data.append("facility_location_id", params.facility_location_id);
        data.append("individuals_data", params.individuals_data) //offenders data
        data.append("date_added", params.date_added);
        data.append("other_form_data", params.other_form_data); //json data for all other fields

        data.append("incident_form_type", "live_nation"); //live_nation, or other incident form types


        //same API call for adding standard incidents
        const response = await fetch(GLOBALS.UPDATE_INCIDENTS_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        // const responseJson = await response.text();
        // console.log("update", responseJson);
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in updating incident." + error);
        }
    }

    async mergeCustomIncidents(params){
        this.getUpdatedCrendetials();
        const data = new FormData();


        //Auth Params
        data.append("license", this.license);
        data.append("auth_username", this.auth_username);
        data.append("token", this.token);

        //Form Details
        data.append("id", params.id);
        data.append("sub_user_id", params.sub_user_id);
        data.append("event_id", params.event_id);
        data.append("facility_id", params.facility_id);
        data.append("facility_location_id", params.facility_location_id);
        data.append("individuals_data", params.individuals_data) //offenders data
        data.append("date_added", params.date_added);
        data.append('location_description',params.location_description);
        data.append("other_form_data", params.other_form_data); //json data for all other fields

        data.append("incident_form_type", "live_nation"); //live_nation, or other incident form types
        data.append("other_incident_id", params.other_incident_id);

        //same API call for adding standard incidents
        const response = await fetch(GLOBALS.MERGE_INCIDENTS_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in merging incidents." + error);
        }
    }
    //End of Live Nation Functions

    async getAllRepeatOffenderByName(name){
        this.getUpdatedCrendetials();

        const params = {
            "license": this.license,
            "auth_username": this.auth_username,
            "token":  this.token,
            "name": name
        }

        const formBody = UserService.sharedInstance.urlEncodeParams(params);
        const response = await fetch(GLOBALS.GET_ALL_REPEAT_OFFENDER_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            //console.log(responseJson);
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Repeat offenders fetch failed.");
        }
    }

    async mergeStandardIncidents(params){
        this.getUpdatedCrendetials();
        let data = new FormData();

        // data.append("files", params.file); //expecting multiple files
        for (let i = 0; i <  params.files.length; i++) {
            data.append("files[]", params.files[i]);
        }

        data.append("auth_username", this.auth_username);
        data.append("token", this.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("dispatch_no", params.dispatch_no)
        data.append("incident_type_id", params.incident_type_id); //expecting multiple files
        data.append("facility_id", params.facility_id);
        data.append("facility_location_id", params.facility_location_id);
        data.append("location_description", params.location_description);
        data.append("individuals_data", params.individuals_data)
        data.append("external_agency_data", params.external_agency_data); //expecting multiple files
        data.append("auto_email_id", params.auto_email_id);
        data.append("date_added", params.date_added);
        data.append("license", this.license);
        data.append("id", params.id);
        data.append("other_incident_id", params.other_incident_id);

        //NOTE: set this flag to 1 if there are attachment changes, it deletes the curretn attachments of the incidents and uploaded the new passed files
        data.append("update_attachments_flag", params.update_attachments_flag);

        const response = await fetch(GLOBALS.MERGE_INCIDENTS_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        //console.log("Incident", responseJson);
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            // console.log(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in merging incidents.");
        }
    }

    async link(params){
        this.getUpdatedCrendetials();


        const finalParams = {
            "license": this.license,
            "auth_username": this.auth_username,
            "token":  this.token,
            "ids": JSON.stringify(params.ids), //array of ids
        }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);

        const response = await fetch(GLOBALS.LINK_INCIDENTS_API, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("saveSchedules error:", error);
        }
    }

    async getHistory(id){
        this.getUpdatedCrendetials();

        const finalParams = {
            "license": this.license,
            "auth_username": this.auth_username,
            "token":  this.token,
            "id": id
        }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);

        const response = await fetch(GLOBALS.GET_INCIDENT_HISTORY_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            }
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("saveSchedules error:", error);
        }
    }

    mergeIncidents = (prev,next) =>{        
        /* absorbed everything from prev to next */
        const other_form_data = UtilsService.sharedInstance.tryParseJSON(next.other_form_data) ? JSON.parse(next.other_form_data) : {};
        const prev_other_form_data = UtilsService.sharedInstance.tryParseJSON(prev.other_form_data) ? JSON.parse(prev.other_form_data) : {};

        /* merge individuals data */
        const individuals_data = [];
        const next_individuals_data = UtilsService.sharedInstance.tryParseJSON(next.individuals_data) ? JSON.parse(next.individuals_data) : [];
        const prev_individuals_data = UtilsService.sharedInstance.tryParseJSON(prev.individuals_data) ? JSON.parse(prev.individuals_data) : [];

        for(let x = 0; x < (next_individuals_data).length; x++){
            const {name} = next_individuals_data[x];

            if(name) individuals_data.push(next_individuals_data[x]);
        }

        for(let x = 0; x < (prev_individuals_data).length; x++){
            const {name} = prev_individuals_data[x];

            if(name) individuals_data.push(prev_individuals_data[x]);
        }

        /* merge attachments data */
        const attachments_data = UtilsService.sharedInstance.tryParseJSON(next.attachments_data) ? JSON.parse(next.attachments_data) : [];
        const prev_attachments_data = UtilsService.sharedInstance.tryParseJSON(prev.attachments_data) ? JSON.parse(prev.attachments_data) : [];

        for(let x = 0; x < (prev_attachments_data).length; x++){
            attachments_data.push(prev_attachments_data[x]);
        }

        /* merge linked incidents */
        const linked_files = other_form_data.linked_files ? other_form_data.linked_files : [];
        const prev_linked_files = prev_other_form_data.linked_files ? prev_other_form_data.linked_files : [];

        for(let x = 0; x < (prev_linked_files).length; x++){
            linked_files.push(prev_linked_files[x]);
        }

        const incident_ids = [];
        const exceptions = ['linked_files'];
        const prev_key = Object.keys(prev_other_form_data);

        for(let x = 0; x < (linked_files).length; x++){
            const {id} = linked_files[x];

            if(incident_ids.indexOf(id) === -1) incident_ids.push(id);
        }

        for(let x = 0; x < (prev_key).length; x++){
            const key = prev_key[x];

            /* if key belongs to any exceptions proceed to next */
            if(exceptions.indexOf(key) >= 0) continue;

            /* if not set in next data, add directly */
            if(!other_form_data[key]){
                other_form_data[key] = prev_other_form_data[key];
            }else{
                const nextValue = other_form_data[key];
                const prevValue = prev_other_form_data[key];

                if(Array.isArray(nextValue)){
                    if(Array.isArray(prevValue)){
                        for(let y = 0; y < (prevValue).length; y++){
                            if((other_form_data[key]).indexOf(prevValue[y]) === -1) (other_form_data[key]).push(prevValue[y]);
                        }
                    }else{
                        if((other_form_data[key]).indexOf(prevValue) === -1) (other_form_data[key]).push(prevValue);
                    }
                }else{
                    other_form_data[key] = other_form_data[key] + `, ${prev_other_form_data[key]}`;
                }
            }
        }

        other_form_data.linked_files = linked_files;
        other_form_data.incident_ids = incident_ids;

        const location_description = next.location_description ? (next.location_description + ', ' + prev.location_description) : prev.location_description;
        const merge = {
            date_added: next.date_added,
            event_id: next.event_id || prev.event_id,
            facility_id: next.facility_id || prev.facility_id,
            facility_location_id: next.facility_location_id || prev.facility_location_id,
            incident_form_type:'live_nation',
            location_description: location_description,
            incident_type_id: next.incident_type_id || prev.incident_type_id,
            other_form_data:JSON.stringify(other_form_data),
            individuals_data:JSON.stringify(individuals_data),
            files:JSON.stringify(attachments_data),
            id:next.id,
            other_incident_id:prev.id,    
            update_attachments_flag:0,
            signature_general_manager: {},
            signature_investigating_manager: {},
        };

        return merge;
    }
}